import {
  isApiMessageText,
  isApiMessageFile,
  isApiMessageButtons,
  isApiMessageService,
} from "../../type-guards";
import { MESSAGE_CHANNEL } from "../../../../packages/constants";
import { getMessageTextData } from "./get-message-text-data";
import { getMessageFileData } from "./get-message-file-data";
import { getMessageButtonsData } from "./get-message-buttons-data";
import { getMessageServiceData } from "./get-message-service-data";
import type { ApiMessage, Message } from "../../types";

export const getMessageData = (
  message: ApiMessage,
  channel: MESSAGE_CHANNEL
): Message | null => {
  const getReplyMessage = (
    replyMessage?: ApiMessage["replyToMessage"] | number
  ): Message | null => {
    if (!replyMessage) {
      return null;
    }

    // На втором уровне является числом
    // Todo обсудить с беком удаление
    if (typeof replyMessage === "number") {
      return null;
    }

    return getMessageData(replyMessage, channel);
  };

  const replyMessage = getReplyMessage(message?.replyToMessage);

  if (isApiMessageText(message)) {
    return { ...getMessageTextData(message, channel), replyMessage };
  }

  if (isApiMessageFile(message)) {
    return { ...getMessageFileData(message, channel), replyMessage };
  }

  if (isApiMessageButtons(message)) {
    return { ...getMessageButtonsData(message, channel), replyMessage };
  }

  if (isApiMessageService(message)) {
    return { ...getMessageServiceData(message, channel), replyMessage };
  }

  return null;
};
